if (!customElements.get('size-guide')) {
  customElements.define(
    'size-guide',
    class SizeGuide extends HTMLElement {
      constructor() {
        super();
        this.openFiltersButton = this.querySelector('[data-open-filters]');
        this.options = this.querySelectorAll('[data-size]');
        this.slider = this.parentElement.querySelector('theme-slider');
      }

      connectedCallback() {
        this.openFilters();
        this.toggleSizes();
      }

      openFilters() {
        if (!this.openFiltersButton) return;
        this.openFiltersButton.addEventListener('click', () => {
          this.classList.toggle('open');
        });
      }

      toggleSizes() {
        if (this.options.length === 0) return;
        this.options.forEach((option) => {
          option.addEventListener('click', () => {
            option.classList.toggle('active');
            const size = option.dataset.size;
            const sizeElements = document.querySelectorAll(`[data-tag="${size}"]`);
            if (option.classList.contains('active')) {
              sizeElements.forEach((element) => {
                element.classList.remove('swiper-slide-hidden');
                element.removeAttribute('aria-hidden');
                element.style.display = 'flex';
              });
            } else {
              sizeElements.forEach((element) => {
                element.classList.add('swiper-slide-hidden');
                element.setAttribute('aria-hidden', true);
                element.style.display = 'none';
              });
            }
            if (this.slider) {
              this.slider.initSlider(true);
            }
          });
        });
      }
    }
  );
}
